<script lang="ts">
  const version = APP_VERSION;
</script>

This tool was created by <a
  href="https://kyle.kiwi"
  target="_blank"
  rel="noopener noreferrer">Kyle Hensel</a
>. The source code is availale
<a
  href="https://github.com/k-yle/tileserver-export"
  target="_blank"
  rel="noopener noreferrer">on GitHub</a
>.

<br />
You're using version <code>{version}</code>
